import { useResponsibilityLetter } from '../../hooks';
import { AcceptDetail } from './components';

export function AcceptedInfos() {
  const { historyResponsibilityLetterState } = useResponsibilityLetter();

  const { isLoading, isError } = historyResponsibilityLetterState;

  if (isLoading || isError) {
    return null;
  }

  const { data } = historyResponsibilityLetterState;

  const lastHistoryChange = data[0];

  return <AcceptDetail acceptDetail={lastHistoryChange} />;
}
